const addFullPageLoader = (onPress?: () => void) => {
  let loader: any = document.getElementById("page-loader");
  loader?.remove?.();

  loader = document.createElement("div");
  loader.id = "page-loader";

  loader.style.cssText = `
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgb(255 255 255 / 75%);
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  `;

  loader.innerHTML = `
    <svg viewBox="0 0 38 38" width="40" height="40"
      xmlns="http://www.w3.org/2000/svg" stroke="#f3123c" role="presentation">
      <g fill="none" fill-rule="evenodd">
        <g transform="translate(2.5 2.5)" stroke-width="5">
          <circle stroke-opacity=".5" cx="16" cy="16" r="16"></circle>
          <path d="M32 16c0-9.94-8.06-16-16-16">
            <animateTransform
              attributeName="transform"
              type="rotate"
              from="0 16 16"
              to="360 16 16"
              dur="1s"
              repeatCount="indefinite" />
          </path>
        </g>
      </g>
    </svg>
  `;

  if (onPress) {
    loader.addEventListener("click", onPress);
  }

  document.body.appendChild(loader);
};

export default addFullPageLoader;
